import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { RootState } from '../../data/reducers';
import { AppDispatch } from '../../data/storeConfig';
import { PrimaryButton } from '../../shared/components/common/primary_button';
import { NavigationShell } from '../../shared/navigation_shell/navigation_shell';
import { MobileInputComponent } from './components/mobile_input_component';
import { OtpInputComponent } from './components/otp_input_component';
import queryString from 'query-string';
import { useNavigate } from 'react-router';
import * as authActions from '../../data/reducers/auth.reducer';
import * as storeActions from '../../data/reducers/store.reducer';
import { useParams } from 'react-router';
import Loader from '../../shared/components/common/loader';

export const LoginMerchantPage = () => {
  const { storeSlug } = useParams<any>();
  const navigate = useNavigate();
  const { storeInfo } = useSelector((state: RootState) => state.storeReducer);
  const { isLoggedIn } = useSelector((state: RootState) => state.authReducer);
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    if(storeSlug){
    dispatch(storeActions.fetchStoreInfo({ storeSlug: storeSlug }));}
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get('token');
    if (token && storeSlug && storeInfo?.merchantStoreId) {
      dispatch(
        authActions.loginMerchant({
          token: token,
          merchantStoreId: storeInfo?.merchantStoreId,
          merchantStoreName: storeInfo.storeName,
          storeSlug: storeSlug,
        }),
      );
    }
  }, [storeInfo]);

  useEffect(() => {
    const queryData = queryString.parse(location.search);
    if (isLoggedIn) {
      if (queryData?.redirectTo != null) {
        navigate(queryData.redirectTo.toString());
      } else {
        navigate(`/${storeSlug}`);
      }
    }
  }, [isLoggedIn]);

  return (
    <div>
      <Loader />
    </div>
  );
};
